import React, { useCallback, useEffect, useState, useRef, createContext, useContext } from 'react';
type ModalContextType = {
  openModal: (onClose?: () => void) => void;
  linkRevealed: boolean;
  setLinkRevealed: (v: boolean) => void;
};
export const ModalContext = createContext<ModalContextType>({
  openModal: () => {},
  linkRevealed: false,
  setLinkRevealed: () => {}
});
export function useModal() {
  return useContext(ModalContext);
}
export function ModalProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [linkRevealed, setLinkRevealed] = useState(false);
  const onCloseRef = useRef<(() => void) | undefined>();
  const openModal = useCallback((onClose?: () => void) => {
    onCloseRef.current = onClose;
    setIsOpen(true);
  }, []);
  const closeModal = useCallback(() => {
    setIsOpen(false);
    if (onCloseRef.current) {
      onCloseRef.current();
      onCloseRef.current = undefined;
    }
  }, []);
  return <ModalContext.Provider value={{
    openModal,
    linkRevealed,
    setLinkRevealed
  }} data-id="element-99">
      {children}
      {isOpen && <div className="fixed inset-0 z-[1000] flex items-center justify-center" style={{
      background: 'rgba(0,0,0,0.45)'
    }} onClick={e => {
      if (e.target === e.currentTarget) closeModal();
    }} data-id="element-100">
          <div className="bg-white rounded-[8px] max-w-[400px] w-[90%] p-[28px_28px_22px] relative" style={{
        boxShadow: '0 8px 40px rgba(0,0,0,0.18)'
      }} data-id="element-101">
            <button className="absolute top-[14px] right-[16px] text-[20px] text-[#aaa] cursor-pointer bg-transparent border-none leading-[1] hover:text-[#333]" onClick={closeModal} data-id="element-102">
              ✕
            </button>
            <div className="text-[26px] mb-[10px]" data-id="element-103">⚠️</div>
            <div className="text-[15px] font-bold text-[#1a1a1a] mb-[10px]" data-id="element-104">
              Dieser Inhalt wurde ausgeblendet
            </div>
            <div className="text-[13px] text-[#555] leading-[1.65] mb-[18px]" data-id="element-105">
              Das ViWe Forum erlaubt keine Werbung oder direkte Produktnennungen
              in Beiträgen. Der Produktname wurde automatisch durch unser System
              gesperrt.
            </div>
            <div className="text-[11px] text-[#aaa] border-t border-[#eee] pt-[12px]" data-id="element-106">
              — Moderationsteam ViWe Forum
            </div>
          </div>
        </div>}
    </ModalContext.Provider>;
}
let clickNachTonFired = false;
export function BlurredBadge({
  children,
  href
}: {
  children: React.ReactNode;
  href?: string;
}) {
  const {
    openModal,
    linkRevealed,
    setLinkRevealed
  } = useModal();
  const [revealed, setRevealed] = useState(false);
  const text = typeof children === 'string' ? children.trim() : '';
  const linkUrl = href || text;
  const isUrl = linkUrl.startsWith('http://') || linkUrl.startsWith('https://');
  // Text badges auto-reveal when the link badge has been revealed
  useEffect(() => {
    if (!isUrl && linkRevealed) {
      setRevealed(true);
    }
  }, [linkRevealed, isUrl]);
  if (revealed) {
    if (isUrl) {
      return <a href={linkUrl} target="_blank" rel="noopener noreferrer" className="inline-block text-[#185FA5] underline text-[12px] font-bold tracking-[0.5px] break-all" onClick={() => {
        if (!clickNachTonFired && typeof (window as any).fbq === 'function') {
          ;
          (window as any).fbq('trackCustom', 'ClickNachTon');
          clickNachTonFired = true;
        }
      }} data-id="element-107">
          {children}
        </a>;
    }
    return <span className="inline-block bg-[#185FA5] text-white px-[10px] py-[2px] rounded-[3px] text-[12px] font-bold tracking-[0.5px]" data-id="element-108">
        {children}
      </span>;
  }
  return <span className="inline-block bg-[#185FA5] text-white px-[10px] py-[2px] rounded-[3px] text-[12px] font-bold select-none tracking-[0.5px] cursor-pointer transition-[filter] duration-200" style={{
    filter: 'blur(4px)'
  }} onMouseEnter={e => {
    e.currentTarget.style.filter = 'blur(3px)';
  }} onMouseLeave={e => {
    e.currentTarget.style.filter = 'blur(4px)';
  }} onClick={() => {
    if (isUrl) {
      // URL badge: on modal close, reveal itself and trigger all text badges
      openModal(() => {
        setRevealed(true);
        setLinkRevealed(true);
      });
    } else {
      // Text badge: just open modal, do NOT reveal on close
      openModal();
    }
  }} data-id="element-109">
      {children}
    </span>;
}